module.exports = __webpack_public_path__ + "static/media/MT1.23ca5d47.mp3";